<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-popover-docs-preview></ui-popover-docs-preview></p>
<h1 id="description">Description</h1>
<p>Generic popover that could contain any html. Easiest way to use this is just to inline this in your html. To create a new custom popover component. Have a look in how selec is built.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span>
    (<span class="hljs-attr">click</span>)=<span class="hljs-string">"popover.open(target)"</span>
    <span class="hljs-attr">ui-popover-target</span>
    #<span class="hljs-attr">target</span>=<span class="hljs-string">"ui-popover-target"</span>
    <span class="hljs-attr">text</span>=<span class="hljs-string">"Open popover"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span>
    (<span class="hljs-attr">mouseover</span>)=<span class="hljs-string">"hoverPopover.open(hoverTarget)"</span>
    <span class="hljs-attr">ui-popover-target</span>
    #<span class="hljs-attr">hoverTarget</span>=<span class="hljs-string">"ui-popover-target"</span>
    <span class="hljs-attr">text</span>=<span class="hljs-string">"Hover to open popover"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">ui-popover</span>
    #<span class="hljs-attr">popover</span>=<span class="hljs-string">"ui-popover"</span>
    [<span class="hljs-attr">config</span>]=<span class="hljs-string">"{{ '{' }} {{ '}' }}"</span>&gt;</span>

    <span class="hljs-tag">&lt;<span class="hljs-name">ng-template</span> <span class="hljs-attr">ui-popover-template</span>&gt;</span>
        Fill this with any HTML
    <span class="hljs-tag">&lt;/<span class="hljs-name">ng-template</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-popover</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">ui-popover</span>
    #<span class="hljs-attr">hoverPopover</span>=<span class="hljs-string">"ui-popover"</span>
    [<span class="hljs-attr">config</span>]=<span class="hljs-string">"{{ '{' }} arrowPosition: 'top', position: 'bottom', openOnHover: true {{ '}' }}"</span>&gt;</span>

    <span class="hljs-tag">&lt;<span class="hljs-name">ng-template</span> <span class="hljs-attr">ui-popover-template</span>&gt;</span>
        Fill this with any HTML
    <span class="hljs-tag">&lt;/<span class="hljs-name">ng-template</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-popover</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
